import React, { useState, useEffect } from "react";
import LandingLayout from "./LandingLayout";
import { MdCheckCircle } from "react-icons/md";
import imgOxiquim from "../../img/img_clientes/Oxiquim.png";
import imgBgnews from "../../img/img_clientes/bgnews.png";
import imgCabal from "../../img/img_clientes/cabal.png";
import imgCopec from "../../img/img_clientes/copec.png";
import imgEnap from "../../img/img_clientes/enap.png";
import imgEnex from "../../img/img_clientes/enex.png";
import imgJlc from "../../img/img_clientes/jlc.png";

const LandingExperiencia = () => {
    const rawClients = [
        { name: "OXIQUIM", logo: imgOxiquim },
        { name: "BG NEWS", logo: imgBgnews },
        { name: "CABAL", logo: imgCabal },
        { name: "COPEC", logo: imgCopec },
        { name: "ENAP", logo: imgEnap },
        { name: "ENEX", logo: imgEnex },
        { name: "JLC", logo: imgJlc },
    ];

    // Duplicate clients 5 times to ensure smooth infinite loop coverage
    const clients = [...rawClients, ...rawClients, ...rawClients, ...rawClients, ...rawClients];

    const [position, setPosition] = useState(0);
    const itemSpacing = 240; // Spacing between items
    const oneSetWidth = rawClients.length * itemSpacing; // Width of one original set

    useEffect(() => {
        const intervalId = setInterval(() => {
            setPosition((prev) => {
                const next = prev + 1.5; // Speed
                // Seamless reset: When we've scrolled past one full set width, reset by subtracting that width
                // reliable reset ensuring no visual jump
                return next >= oneSetWidth ? next - oneSetWidth : next;
            });
        }, 16); // ~60fps

        return () => clearInterval(intervalId);
    }, [oneSetWidth]);

    return (
        <LandingLayout>
            <div className="bg-white py-8 lg:py-12 overflow-hidden relative min-h-screen flex flex-col justify-between">
                {/* Content Section */}
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 flex-grow flex flex-col gap-8">

                    <div className="bg-gray-50 rounded-2xl p-8 lg:p-12 shadow-lg border border-gray-100">
                        <div className="flex flex-col md:flex-row gap-8 items-center">
                            <div className="flex-1">
                                <h3 className="text-2xl font-bold text-gray-800 mb-4 border-l-4 border-amber-500 pl-4">Confianza Corporativa</h3>
                                <div className="space-y-4 text-gray-600 text-lg leading-relaxed text-justify">
                                    <p>
                                        Nuestra sólida trayectoria se refleja en la confianza depositada por las principales empresas del sector energético, industrial y minero en Chile.
                                    </p>
                                    <p>
                                        En <span className="font-bold text-amber-600">ATECMA</span>, no solo prestamos servicios; forjamos alianzas estratégicas. Clientes como <span className="font-semibold text-gray-800">Copec, Enex, Enap, Oxiquim y Lipigas</span> respaldan nuestra excelencia en metrología legal y mantenimiento industrial.
                                    </p>
                                    <p>
                                        Nuestro compromiso con la precisión y el cumplimiento normativo nos ha posicionado como un socio clave para garantizar la operatividad y certificaciones de sus plantas críticas.
                                    </p>
                                </div>
                            </div>
                            {/* Decorative Element */}
                            <div className="md:w-1/3 flex justify-center">
                                <div className="w-48 h-48 bg-amber-100 rounded-full flex items-center justify-center relative">
                                    <div className="absolute w-40 h-40 bg-amber-200 rounded-full animate-pulse opacity-50"></div>
                                    <MdCheckCircle className="text-amber-600 w-24 h-24 relative z-10" />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* 3D Carousel Section - Moved Inside and Aligned */}
                    <div className="relative w-full h-[300px] flex items-center justify-center perspective-1000 bg-gradient-to-t from-gray-50 to-white border border-gray-200 shadow-inner rounded-2xl overflow-hidden">
                        <div className="absolute w-full h-full flex items-center justify-center overflow-hidden">
                            {/* Gradient Overlays for depth fade handles */}
                            <div className="hidden md:block absolute left-0 top-0 w-32 h-full bg-gradient-to-r from-white via-white/80 to-transparent z-20 pointer-events-none" />
                            <div className="hidden md:block absolute right-0 top-0 w-32 h-full bg-gradient-to-l from-white via-white/80 to-transparent z-20 pointer-events-none" />

                            <div className="relative w-full h-full flex items-center justify-center">
                                {clients.map((client, index) => {
                                    // Calculate position relative to the continuous viewport
                                    // We render 5 sets, center is somewhere in the middle.
                                    // Let's anchor relative to screen center.

                                    // To center the strip:
                                    // Total items: 35. Center index: 17.
                                    // But 'position' moves the strip LEFT.

                                    // Let's define xPos relative to "Start" (Screen Center + some Offset?)
                                    // No, simpler: xPos = (Index * Spacing) - Position - (Offset to Center Initial View)

                                    // We want the middle set (set 3 of 5) to be centered initially when pos=0.
                                    // rawClients = 7. 5 sets. 35 items. Middle is item 17 approx.
                                    // We want item 0 of Set 3 to be at some X.
                                    // Let's just create a very wide absolute strip and transform elements.

                                    const initialOffset = (clients.length * itemSpacing) / 2;

                                    // Calculate Absolute X relative to the carousel center container
                                    let realX = (index * itemSpacing) - position - initialOffset;

                                    // Wrap logic manually? No, we reset 'position' to keep it bounded.
                                    // Just stick to the linear calculation.

                                    // Distance processing for concave effect
                                    // items move left (x decreases). 
                                    // Center = 0.

                                    const distanceFromCenter = Math.abs(realX);
                                    const maxDist = 800; // range of effect

                                    // Convex Effect: Center is Large (1.1), Edges are Small (0.6)
                                    // "Va saliendo" = Comes towards viewer at center.

                                    const scaleMin = 0.6;
                                    const scaleMax = 1.1;
                                    // Factor: 1 at center, 0 at edge
                                    const centerFactor = 1 - Math.min(distanceFromCenter, maxDist) / maxDist;

                                    const scale = scaleMin + (scaleMax - scaleMin) * centerFactor;

                                    // Rotation Logic: Face the center (Mirror effect)
                                    // Right Side (positive X): Rotate Y negative (Face Left)
                                    // Left Side (negative X): Rotate Y positive (Face Right)

                                    const maxRot = 50; // Degree of turn at edges
                                    const rotationY = (realX / maxDist) * -maxRot;

                                    // Visibility optimization
                                    if (distanceFromCenter > 1200) return null; // Don't render if far off-screen

                                    // Opacity: fade slightly at edges
                                    const opacity = 0.6 + 0.4 * centerFactor; // More opaque at center

                                    return (
                                        <div
                                            key={`${client.name}-${index}`} // Index needed due to duplication
                                            className="absolute top-1/2 left-1/2 flex flex-col items-center justify-center p-4 transition-transform duration-75 will-change-transform backface-visibility-visible"
                                            style={{
                                                transform: `translate(-50%, -50%) translate3d(${realX}px, 0, 0) scale(${scale}) rotateY(${rotationY}deg)`,
                                                zIndex: 100 - Math.round(distanceFromCenter / 10), // Center (dist=0) -> High Z. Edges -> Low Z. Correct for Convex. 
                                                // Wait, if Center is Small/Far, it should be naturally behind if overlapping?
                                                // Actually with this spacing, they might not overlap much.
                                                // Edges = Larger/Closer = Higher Z.
                                                opacity: opacity,
                                                width: '200px'
                                            }}
                                        >
                                            <div className="w-32 h-32 md:w-36 md:h-36 bg-white rounded-xl shadow-lg flex items-center justify-center p-4 border-2 border-gray-200 hover:border-amber-400 transition-colors duration-300">
                                                <img
                                                    src={client.logo}
                                                    alt={client.name}
                                                    className="max-w-full max-h-full object-contain filter grayscale hover:grayscale-0 transition-all duration-300 transform hover:scale-110"
                                                />
                                            </div>
                                            {/* Optional Name Label */}
                                            <span className={`mt-4 font-bold text-gray-400 text-sm tracking-widest uppercase transition-opacity duration-300 ${distanceFromCenter < 200 ? 'opacity-0' : 'opacity-100'}`}>
                                                {/* Hide label at center if it gets too small? Actually user wanted small at center. */}
                                                {/* Maybe show label only at edges? Or always. Let's keep it clean. */}
                                                {client.name}
                                            </span>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </LandingLayout>
    );
};

export default LandingExperiencia;
